import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { useDialog } from "../licensing/utils/DialogProvider";
import PermissionEditorDialog from "./PermissionEditorDialog";

import { useAuthContext } from "./AuthProvider";
import { connect } from "react-redux";
import axios from "axios";

export const authenticationMode = localStorage.getItem("authenticationMode") === "true";

// (wr)
// 0 not authorized (00)
// 1 read (01)
// 3 write (11)

export const getPermissionRights = (permission, userRoles, vestiging = null, user = null) => {
  let permissionRights = checkSubPermission(permission["write"]) ? 3 : 0;

  if (permissionRights === 3) {
    return permissionRights;
  }
  return checkSubPermission(permission["read"]) ? 1 : 0;

  function checkSubPermission(subPermission) {
    function checkConditions(conditions, isOr = false) {
      const checkCondition = (condition) => {
        switch (condition.type) {
          case "POS":
            return vestiging?.apiProvider === condition.value;
          case "PSP":
            return false;
          case "OR":
            return checkConditions(condition.value, true);
          case "ROLE":
            return true;
          case "SOLUTION":
            return vestiging?.salesarea_type === condition.value;
        }
      };
      // Check conditions
      if (isOr) {
        return conditions.some((condition) => {
          return checkCondition(condition);
        });
      } else {
        return conditions.every((condition) => {
          return checkCondition(condition);
        });
      }
    }

    return subPermission && checkConditions(subPermission);
  }
};

export const getUserPermissionRights = (permissionKey, user) => {
  let permissionRights = checkSubPermission(permissionKey + ":write") ? 3 : 0;

  if (permissionRights === 3) {
    return permissionRights;
  }
  return checkSubPermission(permissionKey + ":read") ? 1 : 0;

  function checkSubPermission(permissionKey) {
    return user.calculatedPermissions[permissionKey] != null;
  }
};

function AuthenticationWrapper(props) {
  const [openDialog] = useDialog();
  const children = props.child ?? props.children;

  const element = useRef(null);

  let { prefix } = useAuthContext();

  let permissionKey = props.usePrefix && prefix ? prefix + "." : "";
  if (props.permissionKey) {
    permissionKey += props.permissionKey;
  } else {
    permissionKey = props.permissionKey;
  }
  useEffect(() => {
    if (element.current?.previousElementSibling) {
      element.current.previousElementSibling.style.outline = "dotted 1px";
      element.current.previousElementSibling.style.outlineColor = props.permissions.permissions[permissionKey]
        ? "black"
        : "red";
      const prevOnClick = element.current.previousElementSibling.onclick;
      element.current.previousElementSibling.onclick = (e) => {
        if (e.altKey) {
          e.preventDefault();
          e.stopPropagation();
          openDialog({
            children: <PermissionEditorDialog permissionKey={permissionKey} />,
            fullWidth: true,
          });
        } else {
          if (prevOnClick) {
            prevOnClick(e);
          }
        }
      };
    }
  }, [element]);

  if (permissionKey != null) {
    const authentication = props.permissions.permissions[permissionKey];

    if (authenticationMode && props.permissions.allPermissions) {
      if (!props.permissions.allPermissions[permissionKey + ":write"]) {
        props.permissions.allPermissions[permissionKey + ":write"] = true;
        axios.create().post("core/permissions", { name: permissionKey + ":write" });
      }
      if (!props.permissions.allPermissions[permissionKey + ":read"]) {
        props.permissions.allPermissions[permissionKey + ":read"] = true;
        axios.create().post("core/permissions", { name: permissionKey + ":read" });
      }
    }

    const userRoles = props.user?.roles?.map((role) => role.name) ?? [];

    const elementProps = { ...props };

    delete elementProps.permissionKey;
    delete elementProps.child;
    delete elementProps.children;
    delete elementProps.user;
    delete elementProps.permissions;
    delete elementProps.dispatch;
    delete elementProps.usePrefix;
    delete elementProps.app;

    const authButtonWrapper = (children) => {
      if (authenticationMode && children) {
        if (Array.isArray(children)) {
          return [
            children.map((child, idx) => React.cloneElement(child, { ...elementProps, key: `${permissionKey}${idx}` })),
            <div
              key={`${permissionKey}a`}
              ref={element}
              style={{
                visibility: "hidden",
              }}
            />,
          ];
        } else {
          return [
            React.cloneElement(children, { ...elementProps, key: `${permissionKey}a` }),
            <div
              key={`${permissionKey}b`}
              ref={element}
              style={{
                visibility: "hidden",
              }}
            />,
          ];
        }
      } else {
        if (children) {
          if (Array.isArray(children)) {
            return children.map((child, idx) =>
              React.cloneElement(child, { ...elementProps, key: `${permissionKey}${idx}` })
            );
          } else {
            return React.cloneElement(children, { ...elementProps, key: `${permissionKey}a` });
          }
        } else {
          return null;
        }
      }
    };

    let permissionCalculated = 0;

    if (
      authentication == null ||
      authenticationMode ||
      (permissionKey === "authenticationMode" && import.meta.env.MODE !== "production")
    ) {
      permissionCalculated = 3;
    } else {
      permissionCalculated = getPermissionRights(authentication, userRoles, props.app.vestiging);
    }

    if (!authenticationMode) {
      permissionCalculated = permissionCalculated & getUserPermissionRights(permissionKey, props.user);
    }

    if (permissionCalculated === 0) {
      return authButtonWrapper(null);
    } else {
      if (typeof children === "function") {
        return authButtonWrapper(children(permissionCalculated === 3));
      } else {
        return authButtonWrapper(children);
      }
    }
  } else {
    if (typeof children === "function") {
      return children(true);
    } else {
      return children;
    }
  }
}

/**
 * @deprecated Niet gebruiken alleen AuthenticationWrapper gebruiken, groetjes Jhorie
 * @param permissionKey
 * @param user
 * @returns {number}
 * @constructor
 */
export function AuthenticationWrapperFunctional(permissionKey, user) {
  let permissionCalculated = 3;

  if (authenticationMode && window.allPermissions) {
    if (!window.allPermissions[permissionKey + ":write"]) {
      window.allPermissions[permissionKey + ":write"] = true;
      axios.create().post("core/permissions", { name: permissionKey + ":write" });
    }
    if (!window.allPermissions[permissionKey + ":read"]) {
      window.allPermissions[permissionKey + ":read"] = true;
      axios.create().post("core/permissions", { name: permissionKey + ":read" });
    }
  }

  return permissionCalculated & getUserPermissionRights(permissionKey, user);
}

AuthenticationWrapper.propTypes = {
  permissionKey: PropTypes.string,
  usePrefix: PropTypes.bool,
  child: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
  children: PropTypes.element,
};

AuthenticationWrapper.defaultProps = {
  usePrefix: true,
};

export default connect((state) => ({
  user: state.user,
  app: state.app,
  permissions: state.permissions,
}))(AuthenticationWrapper);
